import {createFileRoute} from '@tanstack/react-router'
import ClubsView from "../../../players/ClubsView.tsx";

export const Route = createFileRoute('/_app/clubs/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ClubsView />
}
